import {
  BaseCustomerProfileParams,
  CustomerProfileTypeOfBusinessEnum,
} from "../../../types/drayage";
import { FormValidationConfig } from "../Form.types";
import {
  createAlphanumericRule,
  createEmailRule,
  createLengthRule,
  createNumberRangeRule,
  createPhoneRule,
  createRegexRule,
} from "../Form.validators";

export const createCustomerFormValidation = (
  typeOfBusiness: CustomerProfileTypeOfBusinessEnum,
): FormValidationConfig<BaseCustomerProfileParams> => ({
  name: {
    required: true,
    requiredMessage: "Name is required",
    rules: [
      createLengthRule({
        min: 3,
        customMessage: "Name must be at least 3 characters",
      }),
    ],
  },
  typeOfBusiness: {
    required: true,
    requiredMessage: "Type of business is required",
  },
  mcNumber: {
    rules: [
      createLengthRule({
        min: 2,
        customMessage: `${typeOfBusiness === CustomerProfileTypeOfBusinessEnum.FreightForwarder ? "FF" : "MC"} number must be at least 2 characters`,
        allowEmpty: true,
      }),
    ],
  },
  email: {
    required: true,
    requiredMessage: "Email is required",
    rules: [createEmailRule()],
  },
  phoneNumber: {
    required: true,
    requiredMessage: "Phone number is required",
    rules: [createPhoneRule()],
  },
  streetAddress: {
    rules: [
      createLengthRule({
        min: 2,
        customMessage: "Street address must be at least 2 characters",
        allowEmpty: true,
      }),
    ],
  },
  city: {
    rules: [
      createLengthRule({
        min: 2,
        customMessage: "City must be at least 2 characters",
        allowEmpty: true,
      }),
    ],
  },
  state: {
    rules: [
      createLengthRule({
        min: 2,
        customMessage: "State must be at least 2 characters",
        allowEmpty: true,
      }),
    ],
  },
  zip: {
    rules: [
      createLengthRule({
        min: 2,
        max: 10,
        customMessage: "ZIP code must be between 2 and 10 characters",
        allowEmpty: true,
      }),
    ],
  },
  creditLimit: {
    rules: [
      createNumberRangeRule({
        min: 0,
        customMessage: "Credit limit cannot be negative",
        allowNull: true,
        precision: 2,
      }),
    ],
  },
  creditScore: {
    rules: [
      createLengthRule({
        allowEmpty: true,
        customMessage: "Invalid credit score format",
      }),
      createRegexRule({
        pattern: /^\d*\.?\d{0,2}$/,
        customMessage:
          "Credit score must be a valid number with up to 2 decimal places",
        allowEmpty: true,
      }),
    ],
  },
  scacNumber: {
    rules: [
      createAlphanumericRule({
        maxLength: 4,
        customMessage: "SCAC number must be between 2 and 4 characters",
        allowSpaces: false,
        allowedSpecialChars: "",
      }),
      createLengthRule({
        min: 2,
        max: 4,
        allowEmpty: true,
      }),
    ],
  },
  billingEmail: {
    rules: [createEmailRule({ allowEmpty: true })],
  },
  trackingEmail: {
    rules: [createEmailRule({ allowEmpty: true })],
  },
});
